import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Loader2, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatError = (detail) => {
  if (detail == null) return "Login failed. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return String(detail);
};

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      localStorage.setItem("globus_admin_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-globus-navy px-4">
      <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-8 shadow-md">
        <div className="flex flex-col items-start">
          <img src="/globus-logo.png" alt="Globus Financial Services" data-testid="admin-login-logo-img" className="h-24 w-auto" />
          <p className="mt-2 text-[10px] tracking-[0.2em] uppercase text-globus-teal font-semibold">Admin Console</p>
        </div>
        <form onSubmit={submit} className="mt-8 flex flex-col gap-5" data-testid="admin-login-form">
          <div>
            <Label htmlFor="admin-email">Email</Label>
            <Input data-testid="admin-email-input" id="admin-email" type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin email" className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="admin-password">Password</Label>
            <Input data-testid="admin-password-input" id="admin-password" type="password" required
              value={password} onChange={(e) => setPassword(e.target.value)} placeholder="password" className="mt-1.5" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-600">{error}</p>}
          <Button data-testid="admin-login-submit" type="submit" disabled={loading}
            className="rounded-full bg-globus-navy text-white hover:bg-globus-navyLight hover:text-white transition-colors duration-200">
            {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Signing in...</> : "Sign in"}
          </Button>
        </form>
        <Link to="/" data-testid="back-to-site-link"
          className="mt-6 inline-flex items-center text-xs text-slate-500 transition-colors duration-200 hover:text-globus-teal">
          <ArrowLeft className="mr-1 h-3 w-3" /> Back to website
        </Link>
      </div>
    </div>
  );
}
